exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".marker-menu-bloc{background-color:#fff;color:#000}.marker-menu-bloc-buttons{display:flex;align-items:center;justify-content:space-between}.marker-menu-paramtype-selector{display:flex;align-items:center;margin:0 .3rem;padding:.2rem 0}.marker-menu-paramtype-selector-label{margin:0;padding-right:.5rem}", ""]);

